<template>
  <div class="mobile_register">
    <div class="mobile_register_content">
      <h2>hecoos</h2>
      <h3>为保证您能快速通过审核，请填写真实有效的信息</h3>
      <form action="">
        <input v-model="postData.rname" type="text" placeholder="姓名">
        <div class="get_code">
          <input class="code_inp" v-model="postData.phone" type="text" placeholder="手机号">
          <button :disabled="!isPhoneValid || isCountingDown" class="code_btn" @click="getCode">{{ isCountingDown ?
            `${countdown}s后重试` : "获取验证码" }}</button>
        </div>
        <input v-model="postData.verifyCode" type="text" placeholder="验证码"   autocomplete="new-password">
        <input v-model="postData.password" type="password" placeholder="设置密码"   autocomplete="new-password">
        <input v-model="postData.confirmPassword" type="password" placeholder="确认密码">
        <input v-model="postData.email" type="email" placeholder="邮箱">
        <input v-model="postData.company" type="text" placeholder="所在公司名称">
        <input v-model="postData.city" type="text" placeholder="所在城市">
        <input v-model="postData.position" type="text" placeholder="职位">
<!--        <input v-model="postData.workDuration" type="text" placeholder="从业时间（年）">-->

        <select  placeholder="从业时间" :class="{'none_select' : !postData.workDuration}" v-model="postData.workDuration">
          <option value="" disabled selected>从业时间</option>
          <option v-for="item in workDurationList" :value="item.name">{{item.name}}</option>
        </select>

        <input v-model="postData.referrer" type="text" placeholder="推荐人(非必填)">


        <button :disabled="!isButtonEnabled" type="button" @click="handleSubmit">注册</button>
      </form>
      <p>
        <span @click="jumpTo('/')">回首页</span>丨
        <span @click="jumpTo('/login')">已有账户？去登录</span>
      </p>
    </div>
  </div>
</template>
<script>
import { adminRegister, getCaptcha } from "@/api/api"
import { Message } from "element-ui";
export default {
  data() {
    return {
      postData: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
        referrer: "",
      },
      isCountingDown: false,
      countdown: 60,
      workDurationList:[
        {name:'1年'},
        {name:'2年'},
        {name:'3年'},
        {name:'4年'},
        {name:'5年'},
        {name:'6年'},
        {name:'7年'},
        {name:'8年'},
        {name:'9年'},
        {name:'10年以上'}
      ]
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        this.postData.rname &&
        this.postData.email &&
        this.postData.phone &&
        this.postData.verifyCode &&
        this.postData.password &&
        this.postData.confirmPassword &&
        this.postData.company &&
        this.postData.city &&
        this.postData.position &&
        this.postData.workDuration &&
        this.postData.password === this.postData.confirmPassword
      );
    },
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(this.postData.phone);
    },
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url);
    },
    // 获取验证码
    getCode() {
      getCaptcha(this.postData).then(res => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      })
    },
    // 获取验证码倒计时
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
    handleSubmit() {
      adminRegister(this.postData).then(res => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/login");
        } else {
          Message.error(res.message);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile_register {
  width: 100%;
  min-height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-19/b946e97c082f040312c95a399d847c29.png");
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  // background-color: #d0cad4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  .mobile_register_content {
    width: 100%;
    max-width: 370px;
    background-color: #222222;
    padding: 20px;
    border-radius: 6px;
    text-align: center;

    h2{
      font-size: 24px;
      color: #fff;
      margin-bottom: 15px;
    }

    h3 {
      font-size: 16px;
      font-weight: 300;
      color: #fff;
      margin-bottom: 15px;
    }

    input,select {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 12px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #fff;


    }
    select.none_select {
      color: #757575;
    }
    select:focus-visible{
      border: none;
      outline: none;
    }

    .get_code {
      position: relative;

      .code_inp {
        margin-bottom: 10px;
      }

      .code_btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 40% !important;
        background-color: #333333 !important;
        color: #757575 !important;
        margin: 0;
        font-size: 14px;
        padding: 12px;

      }
    }

    button {
      display: block;
      width: 100%;
      font-size: 18px;
      margin-top: 15px;
      padding: 8px;
      border: none;
      border-radius: 6px;
    }

    p {
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
</style>
